import moment, { Moment } from 'moment';

export const createMomentUtc = (timestamp?: number): Moment => {
  return timestamp ? moment.unix(timestamp) : moment();
};
